import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/views/Dashboard'
import ProductAuction from '@/views/ProductAuction'
import ProductDetail from '@/views/ProductDetail'
import AuctionRoom from '@/views/AuctionRoom'
import AuctionResult from '@/views/AuctionResult'
import About from '@/views/About'
import Auctioneers from '@/views/Auctioneers'
import Register from '@/views/Register'
import Profile from '@/views/Profile'
import PaymentSuccess from '@/views/PaymentSuccess'
import AuctionCalendar from '@/views/AuctionCalendar'
import Contact from '@/views/Contact'
import Login from '@/views/Login'
import New1 from '@/components/News/1'
import New2 from '@/components/News/2'
import New3 from '@/components/News/3'
import New4 from '@/components/News/4'
import New5 from '@/components/News/5'
import NewsIndex from '@/components/News/Index'
import Invate1 from '@/components/Invates/1'
import Invate2 from '@/components/Invates/2'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "*",
      redirect: "/home",
    },
    {
      path: '/home',
      name: 'Dashboard',
      component: Dashboard
    },
    // {
    //   path: '/legal-document',
    //   name: 'LegalDocument',
    //   component: LegalDocument
    // },
    {
      path: '/payment',
      name: 'PaymentSuccess',
      component: PaymentSuccess
    },
    {
      path: '/auction/calendar',
      name: 'AuctionCalendar',
      component: AuctionCalendar
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/auctioneers',
      name: 'Auctioneers',
      component: Auctioneers
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/news/:id',
      name: 'NewsIndex',
      component: NewsIndex,
      props: true
    },
    {
      path: "/product/detail/:id",
      name: 'ProductDetail',
      component: ProductDetail,
      props: true
    },
    {
      path: '/product/auction/:id',
      name: 'ProductAuction',
      component: ProductAuction,
      props: true
    },
    {
      path: '/auction/room',
      name: 'AuctionRoom',
      component: AuctionRoom,
    },
    {
      path: '/auction/result',
      name: 'AuctionResult',
      component: AuctionResult,
    },
    {
      path: '/new/1',
      name: 'New1',
      component: New1,
    },
    {
      path: '/new/2',
      name: 'New2',
      component: New2,
    },
    {
      path: '/new/3',
      name: 'New3',
      component: New3,
    },
    {
      path: '/new/4',
      name: 'New4',
      component: New4,
    },
    {
      path: '/new/5',
      name: 'New5',
      component: New5,
    },
    {
      path: '/invates/1',
      name: 'Invate1',
      component: Invate1,
    },
    {
      path: '/invates/2',
      name: 'Invate2',
      component: Invate2,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js